import LayoutComponent from "src/components/user/layout-component";
import ForgetPasswordContainer from "src/containers/user/forget-password-container/forget-password-container";

function ForgetPasswordPage() {
  return (
    <LayoutComponent showLogo={false}>
      <ForgetPasswordContainer />
    </LayoutComponent>
  );
}

export default ForgetPasswordPage;
